module.exports = __webpack_public_path__ + "static/media/Asap-Rocky.fd1907d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/celebrity-influencers/Asap-Rocky.jpg
// module id = 94
// module chunks = 0